import { BaseTemplateElement } from './base-template-element.model';
import { Base } from './report-editor.model';

export class HeaderElement extends BaseTemplateElement {
    useTitle?: boolean;

    constructor(base: Base, useTitle?: boolean) {
        super(base);
        this.useTitle = useTitle;
    }
}
